import * as React from "react";
import { indent } from "./Indent.less";

/** Space between elements */
export const Indent = () => <span data-testid="indent" className={indent} />;
